(ns shared.core.utils.diff)

(defn line-diff
  "The edit script turning lines `a` into lines `b`, as `[:same l]`, `[:removed l]` and `[:added l]` in order, with
   removals ahead of the additions that replace them"
  [a b]
  (let [a (vec a)
        b (vec b)
        n (count a)
        m (count b)
        w (inc m)
        lcs (js/Int32Array. (* (inc n) w))
        at #(aget lcs (+ (* %1 w) %2))]
    (doseq [i (range (dec n) -1 -1)
            j (range (dec m) -1 -1)]
      (aset lcs (+ (* i w) j) (if (= (get a i) (get b j))
                                (inc (at (inc i) (inc j)))
                                (max (at (inc i) j) (at i (inc j))))))
    (loop [i 0
           j 0
           ops []]
      (cond
        (and (< i n) (< j m) (= (get a i) (get b j))) (recur (inc i) (inc j) (conj ops [:same (get a i)]))
        (and (< i n) (or (= j m) (>= (at (inc i) j) (at i (inc j))))) (recur (inc i) j (conj ops [:removed (get a i)]))
        (< j m) (recur i (inc j) (conj ops [:added (get b j)]))
        :else ops))))

(defn- word-char? [c]
  (boolean (some->> c (re-matches #"\w"))))

(defn common-affixes
  "How many leading and trailing characters two strings share, `[prefix suffix]`, pulled back to word boundaries so a
   changed word is marked whole"
  [a b]
  (let [na (count a)
        nb (count b)
        limit (min na nb)
        prefix (or (some #(when (not= (nth a %) (nth b %)) %) (range limit))
                   limit)
        suffix (or (some #(when (not= (nth a (- na 1 %)) (nth b (- nb 1 %))) %) (range (- limit prefix)))
                   (- limit prefix))
        mid-word? (fn [shared-c & edge-cs]
                    (and (word-char? shared-c) (some word-char? edge-cs)))
        prefix (loop [p prefix]
                 (if (and (pos? p) (mid-word? (nth a (dec p)) (get a p) (get b p)))
                   (recur (dec p))
                   p))
        suffix (loop [sfx suffix]
                 (if (and (pos? sfx) (mid-word? (nth a (- na sfx)) (get a (- na sfx 1)) (get b (- nb sfx 1))))
                   (recur (dec sfx))
                   sfx))]
    [prefix suffix]))
